{"footerDetails":"ナビゲーション・出典・法的情報","about":"サイトについて","credits":"クレジット・出典","license":"ライセンス・利用条件","privacy":"プライバシー","sources":"出典・来歴","staff":"ドラゴンボールの制作陣"}